import { render, staticRenderFns } from "./MessageSettingsPage.vue?vue&type=template&id=5af6d494&lang=pug&"
import script from "./MessageSettingsPage.vue?vue&type=script&lang=js&"
export * from "./MessageSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./MessageSettingsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports